import React, { forwardRef, useEffect, useReducer, useState } from "react"
import classes from './ReflectionQuestions.module.css'
import { assessmentsApi } from "../../../../../utils";
import { useSelector } from "react-redux";
import { throwApiError } from "../../../../lms-shared/store/error-handling-actions";
import QuestionListContainer from "../QuestionsListPart/QestionListContainer/QuestionListContainer";
import ReflectionCrud from "../../../../lms-shared/Reflection/ReflectionActions/ReflectionCrud/ReflectionCrud/ReflectionCrud";
import { ActivityTypeEnumText } from "../../../../../models/ActivityTypeEnum";
const TOOLBAR_PORTAL_ID = 'ReflectionQuestionsActionsPortal';

const ReflectionReducer = (reflection, action) => {
    let newState = [...reflection];
    switch (action.type) {
        case 'INIT':
            newState = action.reflection;
            return newState;
        case 'ADD':
            newState.push(action.question);
            return newState;
        case 'EDIT':
            const index = action.question?.id ? newState.findIndex(e => e.id === action.question.id) : action.index
            newState[index] = action.question;
            return newState;
        case 'UPDATE_NEW':
            newState[action.index] = action.question;
            return newState;
        case 'COPY':
            newState.push(action.question);
            return newState;
        case 'DELETE':
            newState.splice(action.index, 1);
            return newState;
        case 'EXCHANGE':
            const temp = newState[action.index]
            newState[action.index] = newState[action.replaceIndex]
            newState[action.replaceIndex] = temp
            return newState;
        default:
            throw new Error('Wrong action type')
    }
};


const ReflectionQuestions = forwardRef(({ lessonId, studyGroupId }) => {
    const { texts } = useSelector(state => state.translate);
    const [reflection, dispatch] = useReducer(ReflectionReducer, []);
    const [index, setCurrentIndex] = useState(0);

    useEffect(() => {
        dispatch({ type: 'INIT', reflection: [] })
    }, [])

    useEffect(() => {
        assessmentsApi.assessmentsFilterRangePost({
            assessmentFilterRange: {
                toCId: lessonId,
                activityType: ActivityTypeEnumText.Reflection,
                studyGroupId: studyGroupId,
            }
        }, (error, resdata, response) => {
            if (error) {
                throwApiError({ userMessage: texts.genralErrorMessage, error: error, statusCode: response?.statusCode, message: "genralErrorMessage " + error.message, level: 2, component: "TrainingsPage", line: 16 })
            } else {
                const temp = []
                resdata?.assessments.forEach(element => {
                    const contentData = JSON.parse(element.contentData)
                    temp.push({ text: contentData.text, type: contentData.type, id: element.id, sortIndex: element.sortIndex })
                });
                dispatch({ type: 'INIT', reflection: temp })
                setCurrentIndex(0)
            }
        })
    }, [])


    const updateReflection = (question) => {
        dispatch({ type: "EDIT", question: question, index: index })
    }

    const updateNewReflection = (question) => {
        dispatch({ type: 'UPDATE_NEW', question: question, index: index })
    }

    const copyReflection = (question) => {
        dispatch({ type: "COPY", question: question })
    }

    const addEmptyReflection = () => {
        dispatch({ type: 'ADD', question: { type: null, text: null } })
        setCurrentIndex(reflection.length)
    }

    const deleteReflection = () => {
        dispatch({ type: 'DELETE', index: index })
        setCurrentIndex(index - 1 >= 0 ? index - 1 : reflection.length == 1 ? index - 1 : 0)
    }

    const changeQuestionOrder = (index, replaceIndex) => {
        dispatch({ type: 'EXCHANGE', index: index, replaceIndex: replaceIndex })
        setCurrentIndex(replaceIndex)
    }

    return (
        <div className={classes.ReflectionContainer}>
            <div className={classes.Title}>{texts.createQuestionsToReflection}</div>
            <div className={classes.ReflectionContentWrapper}>
                <QuestionListContainer
                    reflection={reflection}
                    addReflection={addEmptyReflection}
                    currentIndex={index}
                    setCurrentIndex={setCurrentIndex}
                    portalId={TOOLBAR_PORTAL_ID} />
                <ReflectionCrud
                    reflection={reflection}
                    index={index}
                    lessonId={lessonId}
                    handleUpdateQuestion={updateReflection}
                    handleUpdateNewQuestion={updateNewReflection}
                    handleCopyReflection={copyReflection}
                    handleDeleteQuestion={deleteReflection}
                    handleChangeOrder={changeQuestionOrder}
                    portalId={TOOLBAR_PORTAL_ID}
                />
            </div>
        </div>
    )
})

export default ReflectionQuestions;